export default __webpack_public_path__ + "static/media/48_mobile.acbdcafc.jpg";